/**
 * openExternal — abre um link externo respeitando o wrapper Median (app nativo).
 *
 * No app (iOS/Android via Median) usa `median.window.open(url, "external")` pra
 * abrir no navegador do sistema; no browser normal cai no `window.open`.
 * Mesmo padrão já usado no Profile ("Gerenciar minha conta").
 */
type MedianWindow = { median?: { window?: { open?: (url: string, target: string) => void } } };

export function openExternal(url: string, target = "_blank"): void {
  const median = (window as unknown as MedianWindow).median;
  if (median?.window?.open) {
    median.window.open(url, "external");
  } else {
    window.open(url, target);
  }
}
